import { EmployeeDataDto } from '../dtos/employee-data.dto';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EmployeeDto } from '../dtos/employee.dto';
import { environment } from '../../../../environments/environment';
import { MemoryService } from '../../../core/services/memory.service';
import { UpdateEmployeeDto } from '../dtos/update-employee.dto';
import { ReorderDto } from '../../../shared/dtos/reorder.dto';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  constructor(private http: HttpClient, private memoryService: MemoryService) {
  }

  getEmployees(): Observable<EmployeeDto[]> {
    return this.http.get<EmployeeDto[]>(`${environment.cenplexBookingApiBaseUrl}/customers/${this.memoryService.customerId}/employees`);
  }

  addEmployee(employeeDataDto: EmployeeDataDto): Observable<EmployeeDto> {
    return this.http.post<EmployeeDto>(`${environment.cenplexBookingApiBaseUrl}/customers/${this.memoryService.customerId}/employees`, employeeDataDto);
  }

  updateEmployee(updateEmployeeDto: UpdateEmployeeDto): Observable<EmployeeDto> {
    return this.http.put<EmployeeDto>(`${environment.cenplexBookingApiBaseUrl}/employees/${updateEmployeeDto.employeeId}`, updateEmployeeDto);
  }

  deleteEmployee(employeeId: number): Observable<void> {
    return this.http.delete<void>(`${environment.cenplexBookingApiBaseUrl}/employees/${employeeId}`);
  }

  reorderEmployees(reorderDto: ReorderDto): Observable<void> {
    return this.http.post<void>(`${environment.cenplexBookingApiBaseUrl}/employees/${reorderDto.objectId}/reorder`, reorderDto);
  }

  uploadEmployeeImage(employeeId: number, formData: FormData): Observable<void> {
    return this.http.post<void>(`${environment.cenplexBookingApiBaseUrl}/employees/${employeeId}/image`, formData);
  }

  deleteEmployeeImage(employeeId: number): Observable<void> {
    return this.http.delete<void>(`${environment.cenplexBookingApiBaseUrl}/employees/${employeeId}/image`);
  }
}
